import { ColorLabelProviderAbstract } from './colorlabelprovider.service.abstract';

export class ColorLabelProviderServiceProfit extends ColorLabelProviderAbstract {

  public label(benefit: number, cost: number, invest: number) {
    return this.translateService.instant('RADIAL.DEFAULT.DISPLAY.LABEL.TOP.PROFIT') + ': ' + (benefit - cost - invest);
  }

}
